/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { blockType } from '../../../types';
import CanvasBlockContent from './CanvasBlockContent';
import CanvasBlockControls from './CanvasBlockControls';
import CanvasBlockHighlighter from './CanvasBlockHighlighter';
import * as canvasActions from '../../../actions/canvasBlocks';
import * as selectedBlocksActions from '../../../actions/selectedBlocks';
import * as selectedElementsActions from '../../../actions/selectedElements';
import imageSources from '../../../constants/imageSources/imageSources';
import { UP, DOWN } from '../../../constants/misc';
import * as Styled from './styles';

class CanvasBlock extends Component {
    state = {
        isMouseOverCanvasBlock: false,
    };

    render() {
        const { block, isDragging, selectedBlocks, selectedElements, dispatch, sbBlockLoading } = this.props;
        const { isMouseOverCanvasBlock } = this.state;
        const isCurrBlockSelected = selectedBlocks.includes(block.index);
        const blockData = block.content;
        const { structureLocked } = blockData;

        const blockContainsSelectedElement =
            Object.values(selectedElements.local).filter((el) => el.blockIndex === block.index).length > 0;
        const blockContainsRemoteSelectedElement =
            Object.values(selectedElements.remote).filter((el) => el.blockIndex === block.index).length > 0;
        const { remote: remoteUser = {} } =
            Object.values(selectedElements.remote).find((el) => el.blockIndex === block.index) || {};

        const renderElement = (
            <div
                id={block.index}
                draggable={!blockContainsSelectedElement && block.title !== 'Table'}
                ref={(node) => {
                    this._draggingBlock = node;
                }}
            >
                <Styled.CanvasBlock
                    isDragging={isDragging}
                    structureLocked={structureLocked}
                    cursorSource={imageSources.ICONS.GRAB_CURSOR}
                    isCurrBlockSelected={isCurrBlockSelected}
                    onMouseOver={() => this.setState({ isMouseOverCanvasBlock: true })}
                    onMouseLeave={() => this.setState({ isMouseOverCanvasBlock: false })}
                    onMouseDown={() => {
                        dispatch(selectedElementsActions.removeAllSelectedElements());
                        dispatch(selectedBlocksActions.removeAllSelectedBlocks());
                        dispatch(selectedBlocksActions.addSelectedBlock(block));
                    }}
                >
                    <CanvasBlockHighlighter
                        status={
                            structureLocked ? 'LOCKED' : isCurrBlockSelected && !structureLocked ? 'SELECTED' : null
                        }
                    />
                    <CanvasBlockControls
                        isMouseOverCanvasBlock={isMouseOverCanvasBlock}
                        isCurrBlockSelected={isCurrBlockSelected}
                        blockContainsRemoteSelectedElement={blockContainsRemoteSelectedElement}
                        remoteUser={remoteUser}
                        structureLocked={structureLocked}
                        switchLockStructure={(event) => {
                            event.stopPropagation();
                            dispatch(
                                canvasActions.switchLockStructure({ blockIdx: block.index, prev: structureLocked })
                            );
                        }}
                        switchCheckBox={(event) => {
                            event.stopPropagation();
                            if (isCurrBlockSelected) {
                                dispatch(selectedBlocksActions.removeSelectedBlock(block));
                            } else {
                                dispatch(selectedBlocksActions.addSelectedBlock(block));
                            }
                            dispatch(selectedElementsActions.removeAllSelectedElements());
                        }}
                        moveUpBlock={(event) => {
                            event.stopPropagation();
                            dispatch(canvasActions.moveBlocks({ blocks: [block], direction: UP }));
                        }}
                        moveDownBlock={(event) => {
                            event.stopPropagation();
                            dispatch(canvasActions.moveBlocks({ blocks: [block], direction: DOWN }));
                        }}
                        duplicateBlock={(event) => {
                            event.stopPropagation();
                            dispatch(canvasActions.duplicateBlocks({ blocks: [block] }));
                        }}
                        deleteBlock={(event) => {
                            event.stopPropagation();
                            dispatch(canvasActions.removeBlock(block));
                        }}
                    />

                    <Styled.CanvasBlockContentWrapper structureLocked={structureLocked}>
                        <CanvasBlockContent
                            dispatch={dispatch}
                            blockIndex={block.index}
                            isCurrBlockSelected={isCurrBlockSelected}
                            data={blockData}
                            sbBlockLoading={sbBlockLoading}
                        />
                    </Styled.CanvasBlockContentWrapper>
                </Styled.CanvasBlock>
            </div>
        );

        // required for Firefox and IE (draggable property will be overridden by react-dnd)
        if (blockContainsSelectedElement) {
            return renderElement;
        }

        return renderElement;
    }
}

const mapStateToProps = (state) => ({
    browser: state.browser,
    selectedBlocks: state.selectedBlocks,
    selectedElements: state.selectedElements,
    sbBlockLoading: state.thirdPartyContent.staffbase.populatingID,
});

CanvasBlock.propTypes = {
    block: blockType.isRequired,
    isDragging: PropTypes.bool.isRequired,
    selectedBlocks: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedElements: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    sbBlockLoading: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(CanvasBlock);
